// A table's GameProvider is recreated on rejoin. Keep recently handled busts
// for this app session so that reopening the table cannot replay its prompt.
// Scope by player as well as table: another account must get its own prompt.
const handledBusts = new Set<string>();
const MAX_HANDLED_BUSTS = 2048;

export function claimBustedPrompt(tableId: unknown, playerId: unknown, gameNo: unknown): boolean {
  const identity = [tableId, playerId, gameNo];
  // Wait for an identified snapshot rather than treating missing data as a hand.
  if (identity.some((part) => part === undefined || part === null || String(part) === '')) {
    return false;
  }
  const key = JSON.stringify(identity.map(String));
  if (handledBusts.has(key)) return false;
  handledBusts.add(key);
  if (handledBusts.size > MAX_HANDLED_BUSTS) {
    const oldest = handledBusts.values().next().value;
    if (oldest !== undefined) handledBusts.delete(oldest);
  }
  return true;
}

export function __resetBustedPrompts(): void {
  handledBusts.clear();
}
